import React, { useState, useRef, useEffect, setTimeOut } from "react";
import axios from "axios";

const PartInitiatedModal = ({ closeFunction }) => {
  const [copyText, setCopyText] = useState(true);
  const [clickDownload, setClickDownload] = useState(false);
  const qrRef = useRef();
  const [succesState, setSuccesState] = useState(false);
  const [password, setPassword] = useState("");
  const [imageLoading, setImageLoading] = useState(false);

  return (
    <div className="overlay z-50">
      <div
        className={`modal !min-w-[300px]  !justify-center  relative !px-3 !text-left !items-center !h-fit !py-1 `}
      >
        <div className=" w-full h-full flex justify-center flex-col pt-6 pb-3">
          {" "}
          <p className=" text-sm font-semibold  w-full px-2 text-center">
            Your request is on progress, Kindly comeback after some time.
          </p>
          <div className=" mt-4 flex justify-center ">
            <button
              onClick={() => {
                closeFunction(false);
              }}
              className=" rounded px-3  bg-[#00394d] text-sm font-semibold text-white py-2"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartInitiatedModal;
